export default __webpack_public_path__ + "static/media/crop_type_sugarcane.ffccaa26.jpg";